import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Contact from '../contacts/Contact';
import ContactGroup from '../contacts/ContactGroup';
import NavigationTabs from '../navigation_tabs/NavigationTabs';
import { bindActionCreators } from 'redux';
import { setContactsCount } from '../../actions/Actions';
import TEXTS from "../../locale/texts";

class Contacts extends Component {
  componentWillUnmount() {
    this.props.setContactsCount(null);
  }

  render() {
    const { match, lang } = this.props;
    return (
      <div>
        <NavigationTabs
          match={match}
          secondary
          tabs={[
            {
              component: Contact,
              to: '/contacts',
              title: TEXTS.tabNameContacts[lang]
            },
            {
              component: ContactGroup,
              to: '/groups',
              title: TEXTS.tabNameGroups[lang]
            }
          ]}
        />
        <Switch>
          <Route exact path="/phonebook">
            <Redirect to="/phonebook/contacts" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default withRouter(connect(
  state => ({
    lang: state.lang
  }),
  dispatch => ({
    setContactsCount: bindActionCreators(setContactsCount, dispatch),
  })
)(Contacts));
